import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeStyle } from '@angular/platform-browser'

@Pipe({
  name: 'safeStyle',
  standalone: false,
})
export class SafeStylePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(color: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(color)
  }
}
